import { render, staticRenderFns } from "./EtapaVariacoes.vue?vue&type=template&id=91d348ee&scoped=true"
import script from "./EtapaVariacoes.vue?vue&type=script&lang=js"
export * from "./EtapaVariacoes.vue?vue&type=script&lang=js"
import style0 from "./EtapaVariacoes.vue?vue&type=style&index=0&id=91d348ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d348ee",
  null
  
)

export default component.exports